import React from 'react';
import { GiLaurelCrown } from 'react-icons/gi';

export const Logo = () => {

    return (
        <h4>OtroCieloStore <GiLaurelCrown /></h4>
    )
}
export default Logo